import React, {Component} from "react";
import _ from "i18n";

export default class TypeFormatFilter extends Component {

  render() {
    const {legendType, updateLegendType} = this.props;
    return (
      <div className={"event-registrant-type-container"}>
        <div
          className={"event-registrant-type-option " + (legendType === "TYPE" ? 'selected' : '')}
          onClick={() => updateLegendType('TYPE')}>{_('TYPE')}
          <div className='event-stats-progress-filter-wrapper' >
          </div>
        </div>

        <div
          className={"event-registrant-type-option " + (legendType === "FORMAT" ? 'selected' : '')}
          onClick={() => updateLegendType('FORMAT')}>{_('FORMAT')}
          <div className='event-stats-progress-filter-wrapper'>
            <div className='event-stats-progress-filter-bar'/>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/Filters/EventStats/EventRegistrantLinechart/TypeFormatFilter.js